import React from 'react'
import PropTypes from 'prop-types'
import { useStyles } from './styles'
import LogoDark from '../../images/logo.png'
import LogoLight from '../../images/Educollect-logo.png'

const Logo = (props) => {
    const classes = useStyles(props);
    
    return (
        <div className={classes.root}>
            <img src={ props.logoDark ? LogoDark : LogoLight } alt="logo" className={classes.logo} />
        </div>
    )
}

export default Logo

Logo.propTypes = {
    logoDark: PropTypes.bool,
    logoLight: PropTypes.bool,
}
